import React from "react";

function ViewRolePermissionData({ rolePermissionData, setRolePermission }) {
  if (!rolePermissionData) return null;

  return (
    <div className="fixed overflow-hidden inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        onClick={() => setRolePermission(null)}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
      />

      {/* Modal Card */}
      <div className="relative bg-white w-[95%] max-h-[calc(100%-80px)] overflow-y-auto max-w-2xl rounded-2xl shadow-2xl p-8 animate-[fadeIn_.25s_ease-out]">
        
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-4 mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">
            Role Permission Details
          </h2>

          <button
            onClick={() => setRolePermission(null)}
            className="text-gray-400 hover:text-red-500 transition text-xl"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">

          {/* Role Name */}
          <div>
            <p className="text-gray-500">Role Name</p>
            <p className="font-medium text-gray-800">
              {rolePermissionData?.roleName}
            </p>
          </div>

          {/* Role ID */}
          <div>
            <p className="text-gray-500">Role ID</p>
            <p className="font-mono text-xs text-gray-600 break-all">
              {rolePermissionData?.roleId}
            </p>
          </div>

          {/* Dashboard Permission */}
          <div>
            <p className="text-gray-500">Dashboard Access</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                rolePermissionData?.dashboard === 1
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {rolePermissionData?.dashboard === 1 ? "Allowed" : "Denied"}
            </span>
          </div>

          {/* System Permission */}
          <div>
            <p className="text-gray-500">System Access</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                rolePermissionData?.system === 1
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {rolePermissionData?.system === 1 ? "Allowed" : "Denied"}
            </span>
          </div>

          {/* Status */}
          <div>
            <p className="text-gray-500">Status</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${
                rolePermissionData?.isActive === 1
                  ? "bg-green-100 text-green-700"
                  : "bg-red-100 text-red-600"
              }`}
            >
              {rolePermissionData?.isActive === 1 ? "Active" : "Inactive"}
            </span>
          </div>

          {/* Created */}
          <div>
            <p className="text-gray-500">Created At</p>
            <p className="font-medium text-gray-800">
              {new Date(rolePermissionData?.created_at).toLocaleString()}
            </p>
          </div>

          {/* Updated */}
          <div>
            <p className="text-gray-500">Updated At</p>
            <p className="font-medium text-gray-800">
              {new Date(rolePermissionData?.updated_at).toLocaleString()}
            </p>
          </div>

          {/* Deactivated (if exists) */}
          {rolePermissionData?.deactivatedAt && (
            <div>
              <p className="text-gray-500">Deactivated At</p>
              <p className="font-medium text-gray-800">
                {new Date(rolePermissionData?.deactivatedAt).toLocaleString()}
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="mt-8 text-right">
          <button
            onClick={() => setRolePermission(null)}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewRolePermissionData;